import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";
import { ReactComponent as PlanSvg } from "../images/plantestSite.svg";
import { ReactComponent as Dessins1Svg } from "../images/dessin-1.svg";
import { ReactComponent as Dessin3Svg } from "../images/dessin-3.svg";

const images = [PlanSvg, Dessins1Svg, Dessin3Svg];

const zoomAndMove = keyframes`
  0% {
    transform: translate(-50%, -50%) scale(1) rotate(0deg);
  }
  25% {
    transform: translate(-55%, -45%) scale(1.1) rotate(5deg);
  }
  50% {
    transform: translate(-50%, -55%) scale(1.2) rotate(-5deg);
  }
  75% {
    transform: translate(-45%, -50%) scale(1.1) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) scale(1) rotate(0deg);
  }
`;

const AnimatedBackgroundContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  overflow: hidden;
  background-color: var(--color-background);
`;

const StyledSvg = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 120%;
  height: 120%;
  transform: translate(-50%, -50%);
  opacity: ${(props) => (props.$fading ? 0 : 0.1)};
  animation: ${zoomAndMove} 45s linear infinite;
  transition: opacity 1s ease-in-out;

  svg {
    width: 100%;
    height: 100%;

    * {
      fill: white !important;
      stroke: white !important;
    }
  }
`;

const AnimatedBackground = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setFading(true);
      setTimeout(() => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
        setFading(false);
      }, 1000); // Duration of the fade out
    }, 30000); // Change image every 30 seconds

    return () => clearInterval(interval);
  }, []);

  const CurrentImage = images[currentImageIndex];

  return (
    <AnimatedBackgroundContainer>
      <StyledSvg $fading={fading}>
        <CurrentImage />
      </StyledSvg>
    </AnimatedBackgroundContainer>
  );
};

export default AnimatedBackground;
